import { render, staticRenderFns } from "./IconExport.vue?vue&type=template&id=2d0a61c0&scoped=true"
import script from "./IconExport.vue?vue&type=script&lang=js"
export * from "./IconExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a61c0",
  null
  
)

export default component.exports